export interface TableActionEvent {
  item: any;
  $event: Event;
  action: string;
}
